export const PASSWORD_STATUS = {
    PASSWORD_OK: 'PASSWORD_OK',
    PASSWORD_EXPIRED: 'PASSWORD_EXPIRED',
    PASSWORD_ABOUT_TO_EXPIRE: 'PASSWORD_ABOUT_TO_EXPIRE'
};
